export default "__VITE_ASSET__BY0veO3M__"